import { DEFAULT_SORT, CHANGE_CURRENT_FILTER, RESET_FILTER } from './constants';
import { combineReducers } from 'redux';

const currentFilter = (state = DEFAULT_SORT.id, action) => {
    switch (action.type) {
        case CHANGE_CURRENT_FILTER:
            return action.id;
        case RESET_FILTER:
            return DEFAULT_SORT.id;
        default:
            return state;
    }
};

export default combineReducers({ currentFilter });



// WEBPACK FOOTER //
// ./src/services/directory/reducer.js